// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 386 ? "c185fee2" : chunkId) + "." + {"386":"93b39cee1bf50e2f","421":"1237ca3f1eeec8eb","751":"fbd0704777fd74a8"}[chunkId] + ".js";
};